import React, { useEffect, useState } from "react";
import Menu from "@mui/material/Menu";
import { Grid, styled } from "@mui/material";
import MenuItem, { menuItemClasses } from "@mui/material/MenuItem";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import { IoIosNotifications } from "react-icons/io";
import Badge from "@mui/material/Badge";
import { PostMethod } from "../../Helper/api";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

const Notification = ({ NotificationList }) => {
  const navigate = useNavigate();
  const [NotificationListChild, setNotificationListChild] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const openAvatar = Boolean(anchorEl);
  useEffect(() => {
    if(NotificationList){
      setNotificationListChild(NotificationList)
    }
  }, [NotificationList])
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleCloseAvatar = () => {
    setAnchorEl(null);
  };
  const MenuCell = styled(MenuItem)(() => ({
    [`&.${menuItemClasses.root}`]: {
      fontFamily: "PoppinsMedium",
      borderBottom: "1px solid #ACB0B1",
      display: "flex",
      justifyContent: "flex-start",
      paddingTop: "3%",
      paddingBottom: "3%",
      fontSize: "12px",
    },
  }));
  const MenuCellAnother = styled(MenuItem)(() => ({
    [`&.${menuItemClasses.root}`]: {
      fontFamily: "PoppinsMedium",
      borderBottom: "1px solid #ACB0B1",
      display: "flex",
      justifyContent: "flex-start",
      paddingTop: "3%",
      paddingBottom: "3%",
      fontSize: "18px",
    },
  }));
  const BatchCustom = styled(Badge)(() => ({
    ".MuiBadge-badge": {
      fontFamily: "PoppinsMedium",
      fontSize: "10px",
      backgroundColor: "#E62A4A",
      color: "#FFFFFF",
    },
  }));


  const ClearAllNotification = async () => {
    const Userid =localStorage.getItem("@userid")
    try{
      let url ="notifications/read"
      let params ={
        candidate_uuid:Userid
      }
      let method ="POST"
      const response =await PostMethod({url,params,method})
      if(response.status){ 
        toast.error("Notifications status Updated successfully")
        setNotificationListChild([])
      }else{
        toast.error("Something went wrong")
       
      }
    }catch(Error){
      toast.error("Something went wrong")
      console.log("Error",Error)
    }
  };


  const NotificationDetailsPage = (data) => {
    if(data.job_uuid){
      navigate(`appliedjobs/details/${data.job_uuid}`)
    }
    handleCloseAvatar();
  }

  return (
    <React.Fragment>
      <Tooltip title="Notifications">
        <IconButton
          className="text-black ButtonFoucusNone mx-4"
          onClick={(e) => handleClick(e)}
          sx={{ ml: 2 }}
          aria-controls={openAvatar ? "account-menu" : undefined}
          aria-haspopup="true"
          aria-expanded={openAvatar ? "true" : undefined}
        >
          <BatchCustom badgeContent={NotificationListChild?.length} overlap="circular">
            <IoIosNotifications className="Text-Prime-Black" />
          </BatchCustom>
        </IconButton>
      </Tooltip>

      <Menu
        anchorEl={anchorEl}
        id="account-menu"
        open={openAvatar}
        onClose={handleCloseAvatar}
        className="CustomScroll"
        PaperProps={{
          elevation: 0,
          sx: {
            filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
            bgcolor: "#fff",
            maxHeight: "40%",
            overflow: "auto",
            "& .MuiAvatar-root": {
              width: 40,
              height: 32,
              ml: -0.5,
              mr: 1,
            },
            ".MuiList-root": {
              padding: 0,
            },
            "&:before": {
              content: "''",
              display: "block",
              position: "absolute",
              right: 14,
              width: 10,
              height: 10,
              bgcolor: "#fff",
              transform: "translateY(-50%) rotate(45deg)",
              zIndex: 0,
            },
          },
        }}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
      >
        <MenuCellAnother>
          <Grid container item lg={12} flexDirection={"row"} justifyContent={"space-between"} alignItems={"center"}>
            <Grid item lg={6} container flexDirection={"row"} >
              <p className="poppinsSemiBold px-2 ">Notifications</p>
            </Grid>
            <Grid item lg={6} container flexDirection={"row"} justifyContent={"flex-end"} >
              <span style={{ fontSize: "12px", display: (NotificationListChild?.length == 0 ? "none" : "visible") }} className="mx-2" role="presentation" onClick={() => ClearAllNotification()}>Clear All</span>
            </Grid>
          </Grid>

        </MenuCellAnother>

        {NotificationListChild.length > 0 ? (
          NotificationListChild.map((item, i) => {
            return (
              <MenuCell
                key={i}
                style={{
                  width: "100%",
                }}
              >
                <Grid
                  container
                  lg={12}
                  display={"flex"}
                  flexDirection={"row"}
                  alignItems={"center"}
                  justifyContent={"flex-start"}
                  onClick={() => NotificationDetailsPage(item)}
                >
                  <Grid item lg={12}>
                    <p className="text-capitalize">{item.notification_description}</p>
              
                  </Grid>
                </Grid>
              </MenuCell>
            );
          })
        ) : (
          <MenuCell>
            <Grid item lg={12} container alignItems={"center"} justifyContent={"center"} style={{ width: "250px" }}>
              <p className="poppinsSemiBold pr-3 pl-3">No Notifications Available</p>
            </Grid>
          </MenuCell>
        )}
      </Menu>
    </React.Fragment>
  );
};
export default Notification;
